import { create } from 'zustand';

interface ScoreFilter {
  min: number;
  max: number;
  tiers: string[];
}

interface FilterState {
  searchQuery: string;
  selectedSectors: string[];
  selectedIndustries: string[];
  selectedTags: string[];
  scoreFilters: {
    value: ScoreFilter;
    growth: ScoreFilter;
    health: ScoreFilter;
    momentum: ScoreFilter;
  };
  sortBy: 'value_score' | 'growth_score' | 'health_score' | 'momentum_score' | 'name';
  sortOrder: 'asc' | 'desc';

  setSearchQuery: (query: string) => void;
  setSelectedSectors: (sectors: string[]) => void;
  setSelectedIndustries: (industries: string[]) => void;
  setSelectedTags: (tags: string[]) => void;
  setScoreFilter: (scoreType: 'value' | 'growth' | 'health' | 'momentum', filter: ScoreFilter) => void;
  setSortBy: (sortBy: FilterState['sortBy']) => void;
  setSortOrder: (order: 'asc' | 'desc') => void;
  resetFilters: () => void;
}

const initialState = {
  searchQuery: '',
  selectedSectors: [],
  selectedIndustries: [],
  selectedTags: [],
  scoreFilters: {
    value: { min: 0, max: 100, tiers: [] },
    growth: { min: 0, max: 100, tiers: [] },
    health: { min: 0, max: 100, tiers: [] },
    momentum: { min: 0, max: 100, tiers: [] },
  },
  sortBy: 'value_score' as const,
  sortOrder: 'desc' as const,
};

export const useFilterStore = create<FilterState>((set) => ({
  ...initialState,

  setSearchQuery: (query) => set({ searchQuery: query }),
  setSelectedSectors: (sectors) => set({ selectedSectors: sectors }),
  setSelectedIndustries: (industries) => set({ selectedIndustries: industries }),
  setSelectedTags: (tags) => set({ selectedTags: tags }),
  setScoreFilter: (scoreType, filter) =>
    set((state) => ({
      scoreFilters: {
        ...state.scoreFilters,
        [scoreType]: filter,
      },
    })),
  setSortBy: (sortBy) => set({ sortBy }),
  setSortOrder: (order) => set({ sortOrder: order }),
  resetFilters: () => set(initialState),
}));

